@if (loading$ | async) {
<app-loader></app-loader>
}

<app-toast></app-toast>
<div class="router-container">
  <router-outlet></router-outlet>
</div>
